import {
  Box,
  Button,
  chakra,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  useColorModeValue as mode,
  useDisclosure,
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { Link } from "react-router-dom";

const LoginForm = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { isOpen, onToggle } = useDisclosure();
  const inputRef = useRef();

  const onClickReveal = () => {
    onToggle();
    const input = inputRef.current;
    if (input) {
      input.focus({ preventScroll: true });
      const length = input.value.length * 2;
      requestAnimationFrame(() => {
        input.setSelectionRange(length, length);
      });
    }
  };

  return (
    <chakra.form
      method="POST"
      onSubmit={(e) => {
        e.preventDefault();
        props.onSubmit(email, password);
      }}
    >
      <Stack spacing="6">
        <FormControl id="email">
          <FormLabel>Email address</FormLabel>
          <Input
            name="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            tabIndex={1}
          />
        </FormControl>
        <FormControl id="password">
          <Flex justify="space-between">
            <FormLabel>Password</FormLabel>
            <Box
              tabIndex={4}
              as="a"
              color={mode("red.600", "red.200")}
              fontWeight="semibold"
              fontSize="sm"
            >
              <Link to="/reset">Forgot Password?</Link>
            </Box>
          </Flex>
          <InputGroup>
            <InputRightElement>
              <IconButton
                bg="transparent !important"
                variant="ghost"
                aria-label={isOpen ? "Mask password" : "Reveal password"}
                icon={isOpen ? <HiEyeOff /> : <HiEye />}
                onClick={onClickReveal}
              />
            </InputRightElement>
            <Input
              ref={inputRef}
              name="password"
              type={isOpen ? "text" : "password"}
              autoComplete="current-password"
              required
              tabIndex={2}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </InputGroup>
        </FormControl>
        <Button
          tabIndex={3}
          type="submit"
          colorScheme="red"
          color="white"
          size="lg"
          fontSize="md"
        >
          Sign in
        </Button>
      </Stack>
    </chakra.form>
  );
};

export default LoginForm;
